export default "__VITE_ASSET__DfYSh_K7__"